import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=67614ac7"
import script from "./Window.vue?vue&type=script&lang=ts"
export * from "./Window.vue?vue&type=script&lang=ts"
import style0 from "./Window.vue?vue&type=style&index=0&id=67614ac7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports